export const isAsnOriginShipment = (shipment) => {
  const name = String(shipment?.sourceFileName || shipment?.SourceFileName || '').trim();
  return Boolean(name) && name.toLowerCase() !== 'manual-receive';
};

export const getAsnSourceFileName = (shipment) =>
  String(shipment?.sourceFileName || shipment?.SourceFileName || '').trim();
